module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    directives: [{
      name: "drag",
      rawName: "v-drag:start",
      value: (_vm.dragStart),
      expression: "dragStart",
      arg: "start"
    }],
    style: (_vm.columnStyles),
    attrs: {
      "title": "Click to sort. Drag to center to group."
    },
    on: {
      "click": _vm.sort
    }
  }, [_c('div', {
    staticClass: "datatable-column",
    attrs: {
      "layout": _vm.columnLayout
    }
  }, [_c('div', [_vm._t("default", [_vm._v(_vm._s(_vm.label || _vm.id))])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sorting),
      expression: "sorting"
    }],
    staticClass: "datatable-sort-arrow",
    class: _vm.sortArrowClass
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32af58a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datatable/datatable-column.vue
// module id = 2128
// module chunks = 0